var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid"},[(_vm.isAuth)?_c('div',{staticClass:"grid-item"},[_c('monitor',{attrs:{"projId":_vm.id}})],1):_c('auth-error')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }